import { phoneDigits } from "./contactValidation";

const URL_RE = /(?:https?:\/\/|www\.)[^\s<>"']+/gi;
const PHONE_RE = /(?:\+?\d[\d\s().-]{5,}\d)/g;

function isLikelyPhone(raw) {
  const digits = phoneDigits(raw);
  return digits >= 7 && digits <= 15;
}

function normalizeUrl(raw) {
  const trimmed = raw.replace(/[.,;:!?)]+$/, "");
  if (/^www\./i.test(trimmed)) return `https://${trimmed}`;
  return trimmed;
}

function hrefForPhone(raw) {
  const trimmed = raw.trim();
  const compact = trimmed.replace(/[^\d+]/g, "");
  return compact.startsWith("+") ? `tel:${compact}` : `tel:${trimmed.replace(/\s/g, "")}`;
}

/**
 * Split plain text into text/link segments for inline rendering.
 * URLs and phone-like tokens become link segments.
 */
export function linkifyText(text) {
  const source = String(text || "");
  if (!source) return [];

  const matches = [];

  let match;
  const urlRe = new RegExp(URL_RE.source, "gi");
  while ((match = urlRe.exec(source)) !== null) {
    matches.push({
      start: match.index,
      end: match.index + match[0].length,
      type: "url",
      raw: match[0],
    });
  }

  const phoneRe = new RegExp(PHONE_RE.source, "g");
  while ((match = phoneRe.exec(source)) !== null) {
    const start = match.index;
    const end = start + match[0].length;
    if (matches.some((entry) => start >= entry.start && start < entry.end)) continue;
    const raw = match[0];
    if (!isLikelyPhone(raw)) continue;
    matches.push({ start, end, type: "phone", raw });
  }

  matches.sort((a, b) => a.start - b.start);

  const filtered = [];
  let lastEnd = 0;
  for (const entry of matches) {
    if (entry.start < lastEnd) continue;
    filtered.push(entry);
    lastEnd = entry.end;
  }

  const segments = [];
  let cursor = 0;

  for (const entry of filtered) {
    if (entry.start > cursor) {
      segments.push({ type: "text", text: source.slice(cursor, entry.start) });
    }

    if (entry.type === "url") {
      const href = normalizeUrl(entry.raw);
      segments.push({
        type: "link",
        text: entry.raw,
        href,
        external: true,
      });
    } else {
      segments.push({
        type: "link",
        text: entry.raw,
        href: hrefForPhone(entry.raw),
        external: false,
      });
    }

    cursor = entry.end;
  }

  if (cursor < source.length) {
    segments.push({ type: "text", text: source.slice(cursor) });
  }

  return segments;
}
